/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SalesBaseService } from '../sales-base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { SalesStrictHttpResponse } from '../sales-strict-http-response';

import { SalesQuotePriceListResponseDto } from '../models/sales-quote-price-list-response-dto';
import { quotePriceListsControllerAddComplexity } from '../fn/quote-price-lists/quote-price-lists-controller-add-complexity';
import { QuotePriceListsControllerAddComplexity$Params } from '../fn/quote-price-lists/quote-price-lists-controller-add-complexity';
import { quotePriceListsControllerBatchCreate } from '../fn/quote-price-lists/quote-price-lists-controller-batch-create';
import { QuotePriceListsControllerBatchCreate$Params } from '../fn/quote-price-lists/quote-price-lists-controller-batch-create';
import { quotePriceListsControllerClearComplexities } from '../fn/quote-price-lists/quote-price-lists-controller-clear-complexities';
import { QuotePriceListsControllerClearComplexities$Params } from '../fn/quote-price-lists/quote-price-lists-controller-clear-complexities';
import { quotePriceListsControllerCreate } from '../fn/quote-price-lists/quote-price-lists-controller-create';
import { QuotePriceListsControllerCreate$Params } from '../fn/quote-price-lists/quote-price-lists-controller-create';
import { quotePriceListsControllerFindAllByTenant } from '../fn/quote-price-lists/quote-price-lists-controller-find-all-by-tenant';
import { QuotePriceListsControllerFindAllByTenant$Params } from '../fn/quote-price-lists/quote-price-lists-controller-find-all-by-tenant';
import { quotePriceListsControllerFindOne } from '../fn/quote-price-lists/quote-price-lists-controller-find-one';
import { QuotePriceListsControllerFindOne$Params } from '../fn/quote-price-lists/quote-price-lists-controller-find-one';
import { quotePriceListsControllerRemove } from '../fn/quote-price-lists/quote-price-lists-controller-remove';
import { QuotePriceListsControllerRemove$Params } from '../fn/quote-price-lists/quote-price-lists-controller-remove';
import { quotePriceListsControllerRemoveByCategory } from '../fn/quote-price-lists/quote-price-lists-controller-remove-by-category';
import { QuotePriceListsControllerRemoveByCategory$Params } from '../fn/quote-price-lists/quote-price-lists-controller-remove-by-category';
import { quotePriceListsControllerRemoveComplexity } from '../fn/quote-price-lists/quote-price-lists-controller-remove-complexity';
import { QuotePriceListsControllerRemoveComplexity$Params } from '../fn/quote-price-lists/quote-price-lists-controller-remove-complexity';
import { quotePriceListsControllerReorder } from '../fn/quote-price-lists/quote-price-lists-controller-reorder';
import { QuotePriceListsControllerReorder$Params } from '../fn/quote-price-lists/quote-price-lists-controller-reorder';
import { quotePriceListsControllerUpdate } from '../fn/quote-price-lists/quote-price-lists-controller-update';
import { QuotePriceListsControllerUpdate$Params } from '../fn/quote-price-lists/quote-price-lists-controller-update';
import { quotePriceListsControllerUpdateComplexity } from '../fn/quote-price-lists/quote-price-lists-controller-update-complexity';
import { QuotePriceListsControllerUpdateComplexity$Params } from '../fn/quote-price-lists/quote-price-lists-controller-update-complexity';

@Injectable({ providedIn: 'root' })
export class SalesQuotePriceListsService extends SalesBaseService {
  constructor(config: SalesApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `quotePriceListsControllerFindAllByTenant()` */
  static readonly QuotePriceListsControllerFindAllByTenantPath = '/o2-sales/quote-price-lists/{tenant}';

  /**
   * Retrieve quote price lists by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerFindAllByTenant$Response(params: QuotePriceListsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>> {
    const obs = quotePriceListsControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve quote price lists by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerFindAllByTenant(params: QuotePriceListsControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<SalesQuotePriceListResponseDto>> {
    const resp = this.quotePriceListsControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>): Array<SalesQuotePriceListResponseDto> => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerCreate()` */
  static readonly QuotePriceListsControllerCreatePath = '/o2-sales/quote-price-lists/{tenant}';

  /**
   * Create a new quote price list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerCreate$Response(params: QuotePriceListsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new quote price list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerCreate(params: QuotePriceListsControllerCreate$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerBatchCreate()` */
  static readonly QuotePriceListsControllerBatchCreatePath = '/o2-sales/quote-price-lists/{tenant}/batch/{quoteId}';

  /**
   * Batch create quote price lists from existing price lists.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerBatchCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerBatchCreate$Response(params: QuotePriceListsControllerBatchCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>> {
    const obs = quotePriceListsControllerBatchCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Batch create quote price lists from existing price lists.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerBatchCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerBatchCreate(params: QuotePriceListsControllerBatchCreate$Params, context?: HttpContext): Observable<Array<SalesQuotePriceListResponseDto>> {
    const resp = this.quotePriceListsControllerBatchCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>): Array<SalesQuotePriceListResponseDto> => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerFindOne()` */
  static readonly QuotePriceListsControllerFindOnePath = '/o2-sales/quote-price-lists/{tenant}/id/{id}';

  /**
   * Retrieve a quote price list by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerFindOne$Response(params: QuotePriceListsControllerFindOne$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a quote price list by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerFindOne(params: QuotePriceListsControllerFindOne$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerReorder()` */
  static readonly QuotePriceListsControllerReorderPath = '/o2-sales/quote-price-lists/{tenant}/reorder';

  /**
   * Reorder the price lists of a quote.
   *
   * Persists a full display-ordering snapshot (order within category + category order) for the price lists of a quote in a single bulk operation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerReorder$Response(params: QuotePriceListsControllerReorder$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<void>> {
    const obs = quotePriceListsControllerReorder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Reorder the price lists of a quote.
   *
   * Persists a full display-ordering snapshot (order within category + category order) for the price lists of a quote in a single bulk operation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerReorder(params: QuotePriceListsControllerReorder$Params, context?: HttpContext): Observable<void> {
    const resp = this.quotePriceListsControllerReorder$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerRemove()` */
  static readonly QuotePriceListsControllerRemovePath = '/o2-sales/quote-price-lists/{tenant}/{id}';

  /**
   * Delete a quote price list by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerRemove$Response(params: QuotePriceListsControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a quote price list by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerRemove(params: QuotePriceListsControllerRemove$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerUpdate()` */
  static readonly QuotePriceListsControllerUpdatePath = '/o2-sales/quote-price-lists/{tenant}/{id}';

  /**
   * Update a quote price list by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerUpdate$Response(params: QuotePriceListsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a quote price list by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerUpdate(params: QuotePriceListsControllerUpdate$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerRemoveByCategory()` */
  static readonly QuotePriceListsControllerRemoveByCategoryPath = '/o2-sales/quote-price-lists/{tenant}/category/by-quote';

  /**
   * Delete all quote price lists by quote and category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerRemoveByCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerRemoveByCategory$Response(params: QuotePriceListsControllerRemoveByCategory$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<{
'deletedCount'?: number;
}>> {
    const obs = quotePriceListsControllerRemoveByCategory(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete all quote price lists by quote and category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerRemoveByCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerRemoveByCategory(params: QuotePriceListsControllerRemoveByCategory$Params, context?: HttpContext): Observable<{
'deletedCount'?: number;
}> {
    const resp = this.quotePriceListsControllerRemoveByCategory$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<{
'deletedCount'?: number;
}>): {
'deletedCount'?: number;
} => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerAddComplexity()` */
  static readonly QuotePriceListsControllerAddComplexityPath = '/o2-sales/quote-price-lists/{tenant}/{priceListId}/complexities';

  /**
   * Add a complexity to a quote price list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerAddComplexity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerAddComplexity$Response(params: QuotePriceListsControllerAddComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerAddComplexity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a complexity to a quote price list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerAddComplexity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerAddComplexity(params: QuotePriceListsControllerAddComplexity$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerAddComplexity$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerClearComplexities()` */
  static readonly QuotePriceListsControllerClearComplexitiesPath = '/o2-sales/quote-price-lists/{tenant}/{priceListId}/complexities';

  /**
   * Clear all complexities from a quote price list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerClearComplexities()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerClearComplexities$Response(params: QuotePriceListsControllerClearComplexities$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerClearComplexities(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Clear all complexities from a quote price list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerClearComplexities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerClearComplexities(params: QuotePriceListsControllerClearComplexities$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerClearComplexities$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerRemoveComplexity()` */
  static readonly QuotePriceListsControllerRemoveComplexityPath = '/o2-sales/quote-price-lists/{tenant}/{priceListId}/complexities/{complexityCode}';

  /**
   * Remove a complexity from a quote price list by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerRemoveComplexity()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerRemoveComplexity$Response(params: QuotePriceListsControllerRemoveComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerRemoveComplexity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a complexity from a quote price list by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerRemoveComplexity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotePriceListsControllerRemoveComplexity(params: QuotePriceListsControllerRemoveComplexity$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerRemoveComplexity$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `quotePriceListsControllerUpdateComplexity()` */
  static readonly QuotePriceListsControllerUpdateComplexityPath = '/o2-sales/quote-price-lists/{tenant}/{priceListId}/complexities/{complexityCode}';

  /**
   * Update a complexity in a quote price list by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotePriceListsControllerUpdateComplexity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerUpdateComplexity$Response(params: QuotePriceListsControllerUpdateComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
    const obs = quotePriceListsControllerUpdateComplexity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a complexity in a quote price list by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotePriceListsControllerUpdateComplexity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotePriceListsControllerUpdateComplexity(params: QuotePriceListsControllerUpdateComplexity$Params, context?: HttpContext): Observable<SalesQuotePriceListResponseDto> {
    const resp = this.quotePriceListsControllerUpdateComplexity$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuotePriceListResponseDto>): SalesQuotePriceListResponseDto => r.body)
    );
  }

}
